import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { HardHat, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true);
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#0b0f17] grain-bg flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-lg bg-amber-500/15 border border-amber-500/40 flex items-center justify-center">
            <HardHat className="text-amber-400" size={22} />
          </div>
          <div>
            <div className="font-display font-extrabold text-2xl text-amber-500 leading-none">Grandmont</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-1">Сброс пароля</div>
          </div>
        </div>

        {sent ? (
          <>
            <h1 className="font-display font-bold text-2xl mb-3">Проверьте почту</h1>
            <p className="text-slate-400 text-sm mb-6">
              Если аккаунт с адресом <span className="text-amber-400 font-mono">{email}</span> существует,
              мы отправили письмо со ссылкой на восстановление. Ссылка действительна 1 час.
            </p>
            <Link to="/login" className="text-amber-400 hover:underline text-sm inline-flex items-center gap-1">
              <ArrowLeft size={14} /> Вернуться на вход
            </Link>
          </>
        ) : (
          <>
            <h1 className="font-display font-bold text-2xl mb-2">Забыли пароль?</h1>
            <p className="text-slate-400 text-sm mb-6">
              Введите email — мы пришлём ссылку для сброса.
            </p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <Label htmlFor="email" className="text-slate-300 mb-1.5 block">Эл. почта</Label>
                <Input
                  id="email" data-testid="forgot-email-input" type="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  className="bg-[#131924] border-[#212b3d] focus:border-amber-500 h-11"
                />
              </div>
              <Button
                data-testid="forgot-submit-button" type="submit" disabled={busy}
                className="w-full h-11 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold"
              >
                {busy ? "Отправка…" : "Отправить ссылку"}
              </Button>
            </form>
            <div className="mt-6">
              <Link to="/login" className="text-slate-400 hover:text-amber-400 text-sm inline-flex items-center gap-1">
                <ArrowLeft size={14} /> Назад ко входу
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
